import { useQuery } from '@tanstack/react-query'

import type { ICustomer } from '@albacross/types'

import { get } from 'utils/http'

// The proxy's getCustomer returns the SDK customer plus merged fields; mirrors IRetrieveCustomerResponse + proxy additions without importing the server-side SDK.
export type CustomerDetail = ICustomer & {
  is_sub_account?: boolean
  master_account?: { id: number; name: string } | null
  stripe_customer_id?: string | null
  leads_limit?: number
  workflows?: unknown[]
  // Backend flag marking an agency/master account; not in the SDK type and read only via truthiness, so its shape is unknown here.
  master?: any
}

export const useCustomer = (customerId: any) =>
  useQuery({
    queryKey: ['customer', customerId],
    queryFn: () => get<CustomerDetail>(`/management/customers/${customerId}`),
  })
